<app-so-modal modalId="modal-conversations-wts" verticalposition="center" size="modal-xl" (close)="onClose()"
  [preventClose]="true">


  <div class="modal__header" [style]="{'display':'flex','width':'100%','margin-top':'30px'}">

  </div>
  <!-- End Modal header -->


  <div class="modal__body" [style]="{'padding':'0px'}">

    <div class="d-flex justify-content-center align-content-center">
      <p class="fw-bold" style="font-size: 24px; padding-left: 8px;">{{title | translate}}</p>
    </div>

    <div class="content-form">
      <app-dynamic-table idTable="table-conversations" [config]="config" [columns]="columns" [data]="data"
        (buttonClick)="onButtonClick($event)" (linkClick)="onLinkClick($event)"></app-dynamic-table>
    </div>

    <div class="footer-modal">

    </div>
  </div>


</app-so-modal>



  <app-modal-detalle-mensajes [url]="urlMessages()"></app-modal-detalle-mensajes>
